module.exports = __webpack_public_path__ + "static/media/Zadni_hora.0a542e26.md";